var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'mobile-bg': _vm.isMobile }},[_c('SEOHead',{attrs:{"title":_vm.seoData.title,"description":_vm.seoData.description,"keywords":_vm.seoData.keywords,"structured-data":_vm.seoData.structuredData}}),(!_vm.isMobile)?_c('ProductPricePC'):_c('ProductPriceMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }